import type { ShortcutHandlerContext } from '../../../lib/types.js';
import { resolveFileBrowserSessionParent } from '../../../../files/resolve-file-browser-session-parent.js';

export async function resolveShortcutSessionParent(
  ctx: ShortcutHandlerContext,
  sessionId: string | undefined,
): Promise<string | undefined> {
  if (!ctx.sessionWorktreeManager || !sessionId?.trim()) return undefined;
  return resolveFileBrowserSessionParent(ctx.sessionWorktreeManager, sessionId.trim());
}
